import * as styles from './styles';
import Lottie from 'lottie-web';
import { useEffect, useRef } from 'react';
import * as LoadingAnimation from '@assets/animation/loading.json';

const DisconnectedSubscriber = () => {
  const pendingAnimation = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (pendingAnimation.current) {
      Lottie.loadAnimation({
        container: pendingAnimation.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: LoadingAnimation
      });
    }
  }, [pendingAnimation]);

  return (
    <div css={styles.container}>
      <div css={styles.loadingAnimation} ref={pendingAnimation} />
    </div>
  );
};

export default DisconnectedSubscriber;
